import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(((theme: any) => ({
  container: {
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },

  smallField: {
    width: 120,
  },
  field: {
    width: 220,
  },
  button: {
    width: "150px",
    height: 45,
  },
  submitButton: {
    marginTop: 20,
    width: "150px",
    height: 45,
  },
  savecancel: {
    marginTop: 20,
    width: "100px",
    height: 40,
  },
  buttonContainer: {
    display: "flex",
    gap: 10,
  },
  firstFormContainer: {
    display: "flex",
    flexFlow: "row wrap",
    gap: 4,
    margin: "0px 0px 10px 0px",
  },
  secondFormContainer: {
    display: "flex",
    flexFlow: "row wrap",
    gap: 25,
    margin: "10px 0px 20px 0px",
  },
  requestContainer: {
    display: "flex",
    flexFlow: "column nowrap",
    gap: 15,
  },
  marketInputContainer: {
    display: "flex",
    flexFlow: "column",
  },
  marginInputs: { display: "flex", flex: 1, flexFlow: "row wrap", gap: 5 },
  marketConatiner: {
    display: "flex",
    flexFlow: "column wrap",
    gap: 10,
    marginBottom: 5,
  },

  // New classes for OperatorEditor component
  cancelButton: {
    backgroundColor: "red !important",
    color: "white !important",
  },
  mainContainer: {
    width: "100%",
    padding: theme.spacing(3),
    backgroundColor: "#ffffff",
    minHeight: "100vh",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  paperContainer: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderRadius: theme.spacing(1),
    backgroundColor: "#ffffff",
    border: "1px solid #e0e0e0",
    boxSizing: "border-box",
  },
  sectionTitle: {
    fontWeight: "600 !important",
    color: "#333333 !important",
    marginBottom: theme.spacing(3) + " !important",
    borderBottom: "2px solid #f0f0f0 !important",
    paddingBottom: theme.spacing(1) + " !important",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: theme.spacing(3),
  },
  inputField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fafafa",
      "& fieldset": {
        borderColor: "#e0e0e0",
      },
      "&:hover fieldset": {
        borderColor: "#1976d2",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1976d2",
      },
    },
  },
  whiteBackgroundInput: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white",
    },
  },
  sectionSubtitle: {
    marginBottom: theme.spacing(2) + " !important",
    color: "#666 !important",
    fontWeight: "600 !important",
  },
  divider: {
    margin: "30px 0px !important",
    borderColor: "#e0e0e0 !important",
  },
  simpleDivider: {
    margin: "20px 0px",
  },
  vaultConfigContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr auto",
    gap: theme.spacing(3),
    alignItems: "end",
  },
  saveConfigButton: {
    height: "38px !important",
    padding: "0 " + theme.spacing(3) + " !important",
    backgroundColor: "#1976d2 !important",
    color: "white !important",
    fontWeight: "500 !important",
    "&:hover": {
      backgroundColor: "#1565c0 !important",
    },
    "&:disabled": {
      backgroundColor: "rgba(0,0,0,0.12) !important",
      color: "rgba(0,0,0,0.26) !important",
    },
  },
  lockContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  lockControlBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#f9f9f9",
    borderRadius: theme.spacing(1),
    border: "1px solid #e0e0e0",
  },
  lockSwitchLabel: {
    fontWeight: "500 !important",
    color: "#666 !important",
  },
  lockSwitch: {
    margin: "0 !important",
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1976d2",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1976d2",
    },
  },
  betLimitsPaper: {
    padding: theme.spacing(3) + " !important",
    marginBottom: theme.spacing(3) + " !important",
    borderRadius: theme.spacing(2) + " !important",
  },
  betLimitsTitle: {
    fontWeight: "bold !important",
    color: "#1976d2 !important",
    marginBottom: theme.spacing(1) + " !important",
    display: "flex !important",
    alignItems: "center !important",
    gap: theme.spacing(1) + " !important",
  },
  betLimitsButtonContainer: {
    display: "flex",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  addBetLimitButton: {
    height: "40px !important",
    fontWeight: "bold !important",
    "&.enabled": {
      background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%) !important",
      color: "white !important",
      boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3) !important",
      "&:hover": {
        background: "linear-gradient(45deg, #1976d2 30%, #1cb5e0 90%) !important",
      },
    },
    "&.disabled": {
      background: "rgba(0,0,0,0.12) !important",
      color: "rgba(0,0,0,0.26) !important",
      "&:hover": {
        background: "rgba(0,0,0,0.12) !important",
      },
    },
  },
  removeAllButton: {
    height: "40px !important",
    fontWeight: "bold !important",
    "&.enabled": {
      background: "linear-gradient(45deg, #f44336 30%, #ff6b6b 90%) !important",
      color: "white !important",
      boxShadow: "0 3px 5px 2px rgba(244, 67, 54, .3) !important",
      "&:hover": {
        background: "linear-gradient(45deg, #d32f2f 30%, #ef5350 90%) !important",
      },
    },
    "&.disabled": {
      background: "rgba(0,0,0,0.12) !important",
      color: "rgba(0,0,0,0.26) !important",
      "&:hover": {
        background: "rgba(0,0,0,0.12) !important",
      },
    },
  },
  betLimitItemsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  betLimitItemPaper: {
    padding: theme.spacing(2) + " !important",
    border: "1px solid #e0e0e0 !important",
    borderRadius: theme.spacing(1) + " !important",
    transition: "all 0.3s ease !important",
    "&.disabled": {
      backgroundColor: "#f5f5f5 !important",
      opacity: 0.7,
    },
    "&.enabled": {
      backgroundColor: "white !important",
      opacity: 1,
    },
  },
  betLimitItemFields: {
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "end",
  },
  removeButton: {
    "&.enabled": {
      color: "#f44336 !important",
      "&:hover": {
        backgroundColor: "rgba(244, 67, 54, 0.1) !important",
      },
    },
    "&.disabled": {
      color: "rgba(0,0,0,0.26) !important",
      "&:hover": {
        backgroundColor: "transparent !important",
      },
    },
  },
  overallRtpContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    padding: "16px",
    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  overallRtpTitle: {
    fontWeight: "bold !important",
    marginBottom: "4px !important",
  },
  overallRtpValue: {
    fontWeight: "bold !important",
    color: "#1976d2 !important",
    backgroundColor: "white !important",
    padding: "8px 16px !important",
    borderRadius: "4px !important",
    border: "2px solid #1976d2 !important",
  },
  tableContainer: {
    maxHeight: "600px !important",
    borderRadius: theme.spacing(1) + " !important",
    border: "1px solid #e0e0e0 !important",
  },
  tableHeaderCell: {
    fontWeight: "600 !important",
    backgroundColor: "#f5f5f5 !important",
    color: "#333333 !important",
    fontSize: "0.875rem !important",
    borderBottom: "2px solid #e0e0e0 !important",
  },
  tableHeaderCellRed: {
    fontWeight: "600 !important",
    backgroundColor: "#f5f5f5 !important",
    color: "red !important",
    fontSize: "0.875rem !important",
    borderBottom: "2px solid #e0e0e0 !important",
    textAlign: "center !important",
    minWidth: "200px",
    width: "120px",
  },
  tableHeaderCellCentered: {
    fontWeight: "600 !important",
    backgroundColor: "#f5f5f5 !important",
    color: "#333333 !important",
    fontSize: "0.875rem !important",
    borderBottom: "2px solid #e0e0e0 !important",
    textAlign: "center !important",
    width: "140px",
  },
  tableHeaderCellSmall: {
    fontWeight: "600 !important",
    backgroundColor: "#f5f5f5 !important",
    color: "#333333 !important",
    fontSize: "0.875rem !important",
    borderBottom: "2px solid #e0e0e0 !important",
    textAlign: "center !important",
    width: "100px",
  },
  tableHeaderCellStatus: {
    fontWeight: "600 !important",
    backgroundColor: "#f5f5f5 !important",
    color: "#333333 !important",
    fontSize: "0.875rem !important",
    borderBottom: "2px solid #e0e0e0 !important",
    textAlign: "center !important",
    width: "160px",
  },
  tableRow: {
    "&.error": {
      backgroundColor: "#ffebee !important",
      "&:hover": {
        backgroundColor: "#ffcdd2 !important",
      },
    },
    "&.even": {
      backgroundColor: "#fafafa !important",
      "&:hover": {
        backgroundColor: "#e3f2fd !important",
      },
    },
    "&.odd": {
      backgroundColor: "white !important",
      "&:hover": {
        backgroundColor: "#e3f2fd !important",
      },
    },
    "&.disabled": {
      opacity: 0.7,
    },
  },
  marketName: {
    fontWeight: "bold !important",
    color: "#333 !important",
    textTransform: "capitalize !important",
  },
  rangeChip: {
    display: "inline-block",
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(1),
    fontSize: "0.75rem",
    fontWeight: "bold",
  },
  marginInput: {
    width: "120px !important",
    "& .MuiOutlinedInput-root": {
      "&.enabled": {
        backgroundColor: "white !important",
      },
      "&.disabled": {
        backgroundColor: "#f5f5f5 !important",
      },
      "& fieldset": {
        "&.error": {
          borderColor: "#f44336 !important",
          borderWidth: "2px !important",
        },
        "&.normal": {
          borderColor: "#e0e0e0 !important",
          borderWidth: "1px !important",
        },
      },
      "&:hover fieldset": {
        "&.error": {
          borderColor: "#f44336 !important",
        },
        "&.normal": {
          borderColor: "#1976d2 !important",
        },
      },
      "&.Mui-focused fieldset": {
        "&.error": {
          borderColor: "#f44336 !important",
        },
        "&.normal": {
          borderColor: "#1976d2 !important",
        },
      },
    },
  },
  marginError: {
    color: "#f44336 !important",
    fontSize: "0.7rem !important",
    display: "block !important",
    marginTop: theme.spacing(0.5) + " !important",
    fontWeight: "bold !important",
  },
  rtpChip: {
    display: "inline-block",
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(2),
    fontSize: "0.875rem",
    fontWeight: "bold",
    minWidth: "60px",
    "&.hasValue": {
      backgroundColor: "#e8f5e8",
      color: "#4caf50",
      border: "1px solid #4caf50",
    },
    "&.noValue": {
      backgroundColor: "#f5f5f5",
      color: "#9e9e9e",
      border: "1px solid #e0e0e0",
    },
  },
  statusChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.spacing(2),
    fontSize: "0.75rem",
    fontWeight: "bold",
    minWidth: "80px",
    justifyContent: "center",
    "&.valid": {
      backgroundColor: "#e8f5e8",
      color: "#4caf50",
      border: "1px solid #4caf50",
    },
    "&.invalid": {
      backgroundColor: "#ffebee",
      color: "#f44336",
      border: "1px solid #f44336",
    },
    "&.noData": {
      backgroundColor: "#f5f5f5",
      color: "#9e9e9e",
      border: "1px solid #9e9e9e",
    },
    "&.error": {
      backgroundColor: "#ffebee",
      color: "#f44336",
      border: "1px solid #f44336",
    },
  },
  accessDeniedTitle: {
    fontWeight: "bold !important",
    marginBottom: "16px !important",
  },
  accessDeniedAlert: {
    marginBottom: "16px !important",
  },

  switchContainer: {
    padding: theme.spacing(2) + " !important",
    border: "1px solid #e0e0e0 !important",
    borderRadius: theme.spacing(1) + " !important",
    backgroundColor: "#fafafa !important",
  },

  switchGridContainer: {
    display: "grid !important",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr)) !important",
    gap: theme.spacing(2) + " !important",
  },

  maintenanceContainer: {
    marginTop: theme.spacing(3) + " !important",
    padding: theme.spacing(2) + " !important",
    backgroundColor: "#f9f9f9 !important",
    borderRadius: theme.spacing(1) + " !important",
    border: "1px solid #e0e0e0 !important",
  },

  marginBottom2: {
    marginBottom: theme.spacing(2) + " !important",
  },

  marginBottom3: {
    marginBottom: theme.spacing(3) + " !important",
  },

  textAlignRight: {
    textAlign: "right !important",
  },

  marginBottom4px: {
    marginBottom: "4px !important",
  },

  tableCellCenter: {
    textAlign: "center !important",
  },
})) as any);

export default useStyles;
